// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"TJ-z","smallCardRow":"UJ-z","largeCardRow":"VJ-z","productSearchRow":"WJ-z","curatedRow":"XJ-z"};